import axios from "axios";

export async function loadProducts() {
    let token = '123456789';
    let response = await axios.get(
        '/services/shop/products',
        {
            headers: {
                Authorization: `Bearer ${token}`
            }
        }
    );

    return response.status === 200 ? (response.data || []) : [];
}

export async function getPaymentLink() {
    let token = '123456789';
    let response = await axios.get(
        '/services/paymentLink',
        {
            headers: {
                Authorization: `Bearer ${token}`
            }
        }
    );

    return response.status === 200 ? response.data : null;
}
